<template>
    <div class="callBackProcessModal" >
        <!--患者来电提醒-->
        <el-dialog title="来电提醒" :visible.sync="showCaller" :close-on-click-modal="false" width="35%" :show-close="false">
            <div class="callcss">
                <span>来电号码:</span><span>{{callerInfos.numberStr}}</span>
            </div>
            <div>
                <el-button type="primary" @click="AnswerCallBack()">接听</el-button>
                <!--<el-button type="danger" @click="myHangUp()">挂断</el-button>-->
            </div>
        </el-dialog>
        <!--来电诉求-->
        <el-dialog  :visible.sync="showCallRequest" :close-on-click-modal="false" width="35%" :show-close="false">
            <div class="callcss">
                <span>请选择患者来电({{callerInfos.numberStr}})诉求</span>
            </div>

            <div>
                <el-button type="primary" @click="followRequest()">随访电话</el-button>
                <el-button type="success" @click="feedBack()">反馈问题</el-button>
                <el-button type="danger" @click="myHangUp()">挂断</el-button>
            </div>

        </el-dialog>
        <!--来电诉求-选择患者-->
        <el-dialog :visible.sync="showFollowPatient" :close-on-click-modal="false" width="55%" :show-close="false">
            <div slot="title" class="dialog-title">
                <span class="left">{{callerInfos.numberStr}} 来电 随访信息</span>
                <div class="right">
                    <el-button type="primary" @click="feedBack()">转为反馈问题</el-button>
                    <el-button type="danger" @click="myHangUp()">挂断</el-button>
                </div>
            </div>
            <div class="patient-list">
                <div class="patient-item" v-for=" (patient,index) in followIncomingPatient" :key="index" @click="goDetail(patient)">
                    <span class="patient-baseInfo">
                       {{patient.patientName}}-{{patient.relationshipName}}
                    </span>
                    <span class="patient-time">{{patient.lastCallTime}}</span>
                    <span class="patient-followName">
                        {{patient.callTaskCenterName}}----坐席号（{{patient.userId}}）
                    </span>
                    <span class="state">
                        {{patient.followupStateStr}}
                    </span>

                </div>
            </div>
        </el-dialog>

        <!--来电诉求-反馈内容填写-->
        <el-dialog  :visible.sync="showfillRequest" :close-on-click-modal="false" width="55%" :show-close="false">
            <div slot="title" class="dialog-title">
                <span class="left">填写 {{callerInfos.numberStr}} 来电内容</span>
                <div class="right">
                    <el-button type="primary" @click="followRequest()">转为随访电话</el-button>
                    <el-button type="danger" @click="myHangUp()">挂断</el-button>
                </div>
            </div>

            <div>
                <el-form :model="fillInfo" status-icon :rules="fillInfoRules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="姓名：" prop="username">
                        <!--<el-input type="password" v-model="fillInfo.username" autocomplete="off"></el-input>-->
                        <el-select
                                v-model="fillInfo.username"
                                filterable
                                allow-create
                                default-first-option
                                placeholder="请选择反馈者姓名"  maxlength="10">
                            <el-option
                                    v-for="item in feedBackPatient"
                                    :key="item.patientId"
                                    :label="item.patientName"
                                    :value="item.patientId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="来电诉求:" prop="callersType" >
                        <el-radio-group v-model="fillInfo.callersType" class="muItem">
                            <el-radio :label="'医学问题'">医学问题</el-radio>
                            <el-radio :label="'APP安装问题'">APP安装问题</el-radio>
                            <el-radio :label="'APP下载问题'">APP下载问题</el-radio>
                            <el-radio :label="'APP使用问题'">APP使用问题</el-radio>
                            <el-radio :label="'其他问题'">其他问题</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="备注:" prop="remarks">
                        <el-input
                                type="textarea"
                                :rows="5"
                                placeholder="请输入反馈内容"
                                v-model="fillInfo.remarks" style="width: 400px;"  maxlength="30">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="解决问题:" size="mini">
                        <el-radio-group v-model="fillInfo.isSolve" class="muItem">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item style="justify-content: center">
                        <el-button   class="button" @click="addIncomingTele()">完成</el-button>
                    </el-form-item>
                </el-form>
            </div>

        </el-dialog>
        <el-dialog
                title="确认提示"
                :visible.sync="sureFollow"
                width="30%">
            <span>你确认要对患者【{{patientDetail.patientName}}】进行随访么</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="sureFollow = false">取 消</el-button>
                <el-button type="primary" @click="patientFollowDetail()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    import { RestIncomingCallControllerGetFeedbackPatientInformationList, // 获取反馈问题的患者列表
        RestIncomingCallControllerAddIncomingTelegramAnswerResult,// 添加反馈记录
        RestIncomingCallControllerGetTelephoneFollowupIncomingCallPatientList,// 获取随访患者列表
        RestIncomingCallControllerAddMissedCallResult,// 添加未接来电记录
        RestIncomingCallControllerDelMissedCallResult,//删除来电
    }from "@src/assets/js/api.js";
    import { mapGetters,mapState ,mapMutations} from "vuex";
    export default {
        name:'receiveCaller',
        data() {
            return {
                showCaller: false,//来电记录
                callerInfos:{
                    caller:"18838143070"
                },
                showCallRequest:false,//来电诉求选择
                showfillRequest:false,
                showFollowPatient:false,
                sureFollow:false,
                fillInfo:{
                    username:"",
                    callersType:"",
                    remarks:"",
                    isSolve:true,

                },//来电诉求填写内容
                fillInfoRules:{
                    username:[
                        { required: true, message: '请选择反馈者姓名', trigger: 'blur' },
                    ],
                    remarks:[
                        { required: true, message: '请输入反馈内容', trigger: 'blur' },
                        { min: 5, max: 600, message: '长度在 5 到 600 个字符', trigger: 'blur' }
                    ],
                    callersType: [
                        { required: true, message: '请选择来电诉求', trigger: 'change' }
                    ],
                },
                feedBackPatient:[],
                followIncomingPatient:[],
                patientDetail:{}
            }
        },
        components: {

        },
        computed: {
            ...mapGetters(["username", "userid",]),
        },
        updated(){
        },
        methods:{
            ...mapMutations({
                setContactId:'setContactId'
            }),
            /**
             * 接听电话
             * @constructor
             */
            AnswerCallBack(){
                let vm=this;
                vm.showCallRequest=true;
                vm.showCaller=false
                window.workbench.answer()

            },
            /**
             * 来电诉求-电话随访
             *
             */
            followRequest(){
                //关闭弹窗
                let vm=this;
                vm.showfillRequest=false;
                vm.showCallRequest=false;
                vm.showFollowPatient=true;
                vm.getFollowIncoming()

            },
            async getFollowIncoming(){
                let vm=this;
                let info=new RestIncomingCallControllerGetTelephoneFollowupIncomingCallPatientList();
                info.p_mobilePhone=vm.callerInfos.caller;
                await info.send()
                //随访状态0初始化，1随访中，2成功，3失访，4死亡，5异常呼叫
                info.result.retValue.forEach((item)=>{
                    item.followupStateStr=vm.getfollowState(item.followupState)
                })
                vm.followIncomingPatient=info.result.retValue

            },
            getfollowState(type){
                let str=""
                switch(type) { //（）里写变量，下面直接就写用到的值
                    case 0:
                        str='初始化'
                        break;
                    case 1:
                        str='随访中'
                        break;
                    case 2:
                        str='成功'
                        break;
                    case 3:
                        str='失访'
                        break;
                    case 4:
                        str='死亡'
                        break;
                    case 5:
                        str='异常呼叫'
                        break;
                }
                return str
            },
            /**
             * 来电诉求-反馈问题
             */
            feedBack(){
                let vm=this;
                vm.showCallRequest=false;
                vm.showFollowPatient=false;
                vm.showfillRequest=true;
                vm.getFeedBackPatientList()
            },
            /**
             * 添加来电反馈记录
             */
            async addIncomingTele(){
                let vm=this;
                let isok=true
                this.$refs['ruleForm'].validate((valid) => {
                    if(!valid){
                        isok=false
                    }
                })
                if(!isok){
                    return
                }
                let info=new RestIncomingCallControllerAddIncomingTelegramAnswerResult();
                     info.p_answerUserId=vm.userid
                     info.p_answerUserName=vm.username;
                     let it=vm.feedBackPatient.find(item => item.patientId ==  vm.fillInfo.username)
                     if(it){
                         info.p_patientUserName=it.patientName || vm.fillInfo.username
                         info.p_patientId=it.patientId || ""
                         info.p_admitNo=it.admitNo || ""
                     }else{
                         info.p_patientUserName= vm.fillInfo.username
                     }
                     info.p_incomingTelegramNumber=vm.callerInfos.caller
                     info.p_incomingTelegramAppeal=vm.fillInfo.callersType
                     info.p_appealRemark=vm.fillInfo.remarks;
                     info.p_isSolve=vm.fillInfo.isSolve;
                     info.p_contactId=vm.callerInfos.contactId;
                     info.p_incomingTelegramTime=vm.callerInfos.callTime;
                     await  info.send()
                if(info.result.status==0){
                    this.$message({
                        type: "success",
                        message: '反馈信息保存成功'
                    });
                    vm.myHangUp()
                }else{
                    this.$message({
                        type: "error",
                        message: '反馈信息保存失败'
                    });
                }
            },
            /**
             * 获取匹配的患者列表
             */
            async getFeedBackPatientList(){
                let vm=this;
                let info=new RestIncomingCallControllerGetFeedbackPatientInformationList();
                info.p_mobilePhone=vm.callerInfos.caller
                await  info.send()
                console.log("ddddddddddddddddd============>",info.result)
                if(info.result.status==0 && info.result.retValue.length>0){
                    vm.feedBackPatient=info.result.retValue
                }else{
                    vm.feedBackPatient=[]
                }
                vm.$set(vm, 'feedBackPatient', info.result.retValue)
            },
            goDetail(patient){
                let vm=this
                //if(patient.followupState!=0 && patient.userId == vm.userid){
                if(patient.followupState!=0 ){
                    this.$message({
                        type: "waring",
                        message: '该患者当前正在随访中/已完成本次随访'
                    });
                    return
                }
                vm.patientDetail=patient
                vm.sureFollow=true
            },
            patientFollowDetail(){
                let vm=this
                let patient=vm.patientDetail
                if(vm.callerInfos.contactId) {
                    vm.setContactId(vm.callerInfos.contactId);
                    setTimeout(() => {
                        vm.$router.push({
                            path: "/patient",
                            query:{
                                id:patient.id,
                                taskType: patient.callType,
                                abnormal:1,
                                isCallBack:true,
                                callTaskId:patient.callTaskId,
                                patientId:patient.patientId,
                                callNumber:vm.callerInfos.caller
                            }
                        });
                        vm.closeAllModel();
                    },300)
                }else {
                    this.$message.error('未获取到录音ID，请尝试重新登录')
                }

            },
            myHangUp(){
                let vm=this;
                console.log("Dddddd")
                vm.closeAllModel();
                console.log("window.workbench======+>",window.workbench)
                window.workbench && window.workbench.hangUp();
                console.log("电话前状态==挂断后===》",window.workbench.getStatusCode());

            },
            closeAllModel(){
                let vm=this;
                vm.showCallRequest=false;
                vm.showFollowPatient=false;
                vm.showfillRequest=false;
                vm.showCaller=false;
                vm.sureFollow=false;
                vm.patientDetail={}
            },
            async addMissedCalls(){
                let vm=this;
                vm.closeAllModel();
                console.log("增加一条未接来电")
                let info=new RestIncomingCallControllerAddMissedCallResult();
                info.p_answerUserId=vm.userid;
                info.p_answerUserName=vm.username;
                info.p_incomingTelegramNumber=vm.callerInfos.caller;
                info.p_incomingTelegramTime=vm.callerInfos.callTime;
                await info.send()
            },
            getCurrentDate(){
                let date=new Date()
                let year=date.getFullYear()
                let month=(date.getMonth() + 1)
                month= month<9 ?'0'+month : month
                let day=date.getDate();
                day= day<9 ?'0'+day : day
                let H= date.getHours();
                let M=date.getMinutes();
                let S=date.getSeconds();
                return year+'-'+month+'-'+day+' '+H+":"+M+':'+S
            },
            async delMissedCall(){
                let vm=this;
                let info=new RestIncomingCallControllerDelMissedCallResult();
                info.p_mobilePhone = vm.callerInfos.caller;
                await info.send()

            },

        },
        mounted(){
            let vm=this;
            /**
             * 接入来电电话
             */
            window.pubsub && window.pubsub.on('call-back',(params)=>{
                console.log("dddddd+=====>",params, JSON.stringify(params),JSON.stringify(Array.from(params)));
                vm.callerInfos=params[1]
                var pat=/(\d{3})\d*(\d{4})/
                vm.callerInfos.numberStr=vm.callerInfos.caller.replace(pat,'$1****$2');
                vm.showCaller=true;
                vm.callerInfos.callTime=vm.getCurrentDate()

            });
            /**
             * 挂断电话监听
             * 参数type值为ringing代表呼入未接时挂机
             * 参数type值为dialing代表呼出未接时挂机
             * 参数type值为inbound代表呼入通话，通话中挂断
             * 参数type值为outbound代表呼出通话，通话中挂断
             */
            window.pubsub && window.pubsub.on('call-hang-up',(type)=>{
                // 呼入未接听时，添加一条未接来电
                console.log("Dddddddddd=======",vm.callerInfos.caller)
               if(type=='ringing'){
                   vm.addMissedCalls()
               }else if(vm.callerInfos.caller){
                   vm.delMissedCall()
               }
               setTimeout(()=>{
                   vm.callerInfos={
                       caller:""
                   }
               },1000)
            });
            /**
             * 坐席回拨患者电话
             * Seat call back patient
             */
            window.pubsub && window.pubsub.on('seat-call-back-patient',(infos)=>{
                vm.callerInfos.caller=infos.caller
                var pat=/(\d{3})\d*(\d{4})/
                vm.callerInfos.numberStr=infos.caller.replace(pat,'$1****$2');
                vm.showCallRequest=true;
                vm.callerInfos.callTime=vm.getCurrentDate()
            });

        }



    }
</script>

<style  lang="scss">
    .callBackProcessModal{
        .callcss{
            height: 78px;
            span{
                font-size: 30px;
                color: black;
                &:last-child{
                    margin-left: 15px;
                }
            }
        }
        .dialog-title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid rgba(0,0,0,0.2);
            padding-bottom: 10px;
            .left{
                width: 62%;
                font-size: 26px;
                color: #000;
                min-width: 400px;
                text-align: left;
            }
            .right{
                width: 50%;
                display: flex;
                justify-content: flex-end;
            }
        }
        .patient-list{
            padding-top: 10px;
            .patient-item{
                height: 40px;
                display: flex;
                font-size: 18px;
                color: #000;
                border-bottom: 1px solid rgba(0,0,0,0.2);
                cursor: pointer;
                align-items: center;
                span{
                    text-align: left;
                }
                &:hover{
                    color: #248cfa;
                    font-size: 20px;
                    transform:scale(1);
                }
                .patient-baseInfo{
                    width: 20%;
                }
                .patient-time{
                    width: 20%;
                }
                .patient-followName{
                    width: 40%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .state{
                    width: 20%;
                }

            }
        }
        .el-form-item{
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .el-form-item__content{
            display: flex;
            justify-content: flex-start;
            margin-left:0 !important;
        }
    }
    .button{
        button{
            width: 120px;
            margin: 0 auto;
        }

    }
</style>
